import { createAction } from 'typesafe-actions';
import { RecommendedContactsState } from './types';

export const SET_RECOMMENTDED_CONTACTS_PAGE_LOADING =
  'SET_RECOMMENTDED_CONTACTS_PAGE_LOADING';
export const setRecommendedContactsPageLoading = createAction(
  SET_RECOMMENTDED_CONTACTS_PAGE_LOADING
)<RecommendedContactsState>();
